import FingerprintJS from '@fingerprintjs/fingerprintjs';
const FingerPrintHash = async () => {
    let fingerprint = '';
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const { screenFrame, hdr, screenResolution, colorDepth, availableScreenResolution, pixelRatio, colorGamut, ...components } =
        result.components;
    const visitorId = FingerprintJS.hashComponents(components);
    if (visitorId) {
        fingerprint = visitorId;
    }
    return fingerprint;
};
export default FingerPrintHash;
